<template>
  <div class="ContactUsPage Pt75">
    <div class="box">


      <section class="contact-hero">
        <div class="hero-image">
          <!-- 将图片的 src 绑定到 selectedLocation.img 或 img_phone -->-
          <img :src="selectedLocation.img" alt="Waykar Global Presence">-
          <img :src="isMobile ? selectedLocation.img_phone : selectedLocation.img" alt="Waykar Global Presence">+  <img :src="isMobile ? selectedLocation.img_phone : selectedLocation.img" alt="Waykar Global Presence">
        </div>
        <div class="hero-content">
          <div
              v-for="location in locations"
              :key="location.name"
              class="info-block"
              @click="selectLocation(location)"
              :class="{ 'active': selectedLocation === location }"
          >
            <h2 :class="{ 'no-margin': !location.address && isMobile }">{{ location.name }}</h2>
            <p v-if="location.address">地址：{{ location.address }}</p>
          </div>
        </div>
      </section>


      <!-- 新增的三个模块 -->
      <section class="partnership-section">
        <div class="partnership-container">
          <div class="partnership-card" @mouseenter="showEmail('HR@waykar.com')" @mouseleave="hideEmail">
            <img class="contact-img" src="/images/加入我们.png">
            <h3>加入我们</h3>
            <p>寻找充满激情的人才加入我们的团队</p>
            <transition name="slide-fade">
              <div v-if="hoveredEmail === 'HR@waykar.com' || isMobile" class="email-display" @click="sendEmail('HR@waykar.com')">邮箱：HR@waykar.com</div>
            </transition>
          </div>

          <div class="partnership-card" @mouseenter="showEmail('rex@waykar.com')" @mouseleave="hideEmail">
            <img class="contact-img" src="/images/供应商.png">
            <h3>成为供应商</h3>
            <p>与我们合作，提供高质量的产品和服务</p>
            <transition name="slide-fade">
              <div v-if="hoveredEmail === 'rex@waykar.com' || isMobile" class="email-display" @click="sendEmail('rex@waykar.com')">邮箱：rex@waykar.com</div>
            </transition>
          </div>

          <div class="partnership-card" @mouseenter="showEmail('sales@waykar.com')" @mouseleave="hideEmail">
            <img class="contact-img" src="/images/合作伙伴.png">
            <h3>成为合作伙伴</h3>
            <p>携手共创美好未来，实现互利共赢</p>
            <transition name="slide-fade">
              <div v-if="hoveredEmail === 'sales@waykar.com' || isMobile" class="email-display" @click="sendEmail('sales@waykar.com')">邮箱：sales@waykar.com</div>
            </transition>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>


<script>
export default {
  name: 'ContactUsPage',
  data() {
    return {
      locations: [
        {
          name: '深圳总部',
          phonename: '深圳',
          address: '广东省深圳市龙华区金鼎盛科创园A-1702',
          concat: '0755-21085376',
          img: 'https://img2.xwxwxw.com.cn/images/公司5.png',
          img_phone: 'https://img2.xwxwxw.com.cn/images/公司5.png',
        },
        {
          name: '江门高新区产业园',
          phonename: '江门',
          address: '中国江门高新区',
          concat: '0755-21085376',
          img: 'https://img2.xwxwxw.com.cn/images/公司1.png',
          img_phone: 'https://img2.xwxwxw.com.cn/images/公司1.png',
        },
        {
          name: '美国南卡罗来纳州仓储中心',
          phonename: 'USA.1',
          address: 'South Carolina, USA.',
          concat: '',
          img: 'https://img2.xwxwxw.com.cn/images/公司2.jpg',
          img_phone: 'https://img2.xwxwxw.com.cn/images/公司2.jpg',
        },
        {
          name: '美国加州办事处与仓储中心',
          phonename: 'USA.2',
          address: 'California, USA.',
          concat: 'US+1(626)-251-8646 ',
          img: 'https://img2.xwxwxw.com.cn/images/公司3.jpeg',
          img_phone: 'https://img2.xwxwxw.com.cn/images/公司3.jpeg',
        },
        {
          name: '菲律宾社交媒体营销团队&客户服务中心',
          phonename: '菲律宾',
          address: 'Baguio City, Philippine.',
          concat: '',
          img: 'https://img2.xwxwxw.com.cn/images/公司4.png',
          img_phone: 'https://img2.xwxwxw.com.cn/images/公司4.png',
        },
        {
          name: '泰国工厂',
          phonename: '泰国',
          address: '',
          concat: '',
          img: 'https://img2.xwxwxw.com.cn/images/公司51.jpg',
          img_phone: 'https://img2.xwxwxw.com.cn/images/公司5.jpg',
        },
        {
          name: '印尼工厂',
          phonename: '印尼',
          address: '',
          concat: '',
          img: 'https://img2.xwxwxw.com.cn/images/公司6.jpg',
          img_phone: 'https://img2.xwxwxw.com.cn/images/公司6.jpg',
        }
      ],
      selectedLocation: null, // 新增状态变量，用于存储当前选中的地点
      hoveredEmail: '', // 用于存储当前悬停显示的邮箱
      isMobile: false // 用于检测是否为移动设备
    };
  },
  methods: {
    selectLocation(location) {
      this.selectedLocation = location; // 更新选中的地点
    },
    showEmail(email) {
      this.hoveredEmail = email; // 设置当前悬停显示的邮箱
    },
    hideEmail() {
      this.hoveredEmail = ''; // 清除悬停显示的邮箱
    },
    copyEmail(email) {
      navigator.clipboard.writeText(email).then(() => {
        // 可以添加复制成功的提示
        console.log('邮箱已复制到剪贴板: ' + email);
      }).catch(err => {
        console.error('复制失败: ', err);
      });
    },
    sendEmail(email) {
      window.location.href = `mailto:${email}`;
    },
    // 检测是否为移动设备
    checkIsMobile() {
      this.isMobile = window.innerWidth <= 768;
    }
  },
  created() {
    // 初始化时默认选中第一个地点
    this.selectedLocation = this.locations[0];
  },
  mounted() {
    // 组件挂载时检测是否为移动设备
    this.checkIsMobile();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkIsMobile);
  },
  beforeUnmount() {
    // 组件销毁前移除事件监听
    window.removeEventListener('resize', this.checkIsMobile);
  }
};
</script>

<style scoped>
.Pt75 { padding: 55px 0 45px;  background-color: #f8f9fa; }
.box { max-width: 1400px; margin: 0 auto; padding: 0 15px; }

/* 新增的合作伙伴模块样式 */
.partnership-section {
  margin-bottom: 50px;
}

.partnership-container {
  display: flex;
  gap: 30px;
  justify-content: center;
  flex-wrap: wrap;
}

.partnership-card {
  background-color: #fff;
  border-radius: 12px;
  padding: 30px;
  flex: 1;
  min-width: 250px;
  max-width: 350px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  padding-bottom: 60px; /* 为邮箱显示预留空间 */
}

.partnership-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0,0,0,0.15);
}

.contact-img {
  width: 17%;
}

.partnership-card h3 {
  font-size: 22px;
  font-weight: 600;
  color: #47975a;
  margin-bottom: 15px;
}

.partnership-card p {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
}

/* 邮箱显示样式 */
.email-display {
  position: absolute;
  bottom: 15px;
  left: 15px;
  right: 15px;
  color: #47975a;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 17px;
  background-color: transparent;
}

/* 邮箱操作按钮样式 */
.email-actions {
  position: absolute;
  bottom: 15px;
  right: 15px;
  display: flex;
  gap: 8px;
}

.action-btn {
  background: transparent;
  border: 1px solid #47975a;
  color: #47975a;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-btn:hover {
  background-color: #47975a;
  color: white;
}

/* 滑动淡入淡出动画 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from {
  transform: translateY(10px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

/* 英雄区域样式 */
.contact-hero {
  display: flex;
  gap: 30px;
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  margin-bottom: 50px;
}
.hero-image {
  flex-basis: 64%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 8px;
}
.hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.hero-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.info-block {
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}
.info-block:last-child {
  margin-bottom: 0;
}
.info-block h2 {
  font-size: 22px;
  font-weight: 600;
  color: #47975a;
}
.info-block p {
  font-size: 16px;
  color: #555;
  margin-top: 10px;
  line-height: 1.7;
  display: flex;
  align-items: center;
}
.info-block i {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.7;
}
/* 在这里你可以用SVG或者图片作为icon */
/* .icon-location { background-image: url('...'); } */

/* 响应式设计 */
@media (max-width: 992px) {
  .contact-hero { 
    flex-direction: column;
    padding: 20px;
  }
  
  .hero-image {
    flex-basis: auto;
    height: 300px;
    max-height: 300px;
  }
  
  .hero-content {
    width: 100%;
  }
  
  .partnership-container {
    flex-direction: column;
    align-items: center;
  }
  
  .partnership-card {
    width: 100%;
    max-width: 100%;
  }
}

@media screen and (max-width: 48rem) {
  .Pt75 { 
    padding-top: 1.5rem; 
    padding-bottom: 1.5rem; 
  }

  .email-display {
  }

  
  .box { 
    padding: 0 7px;
  }

  .contact-hero {
    padding: 10px;
    margin-bottom: 2rem;
    gap: 1.25rem;
  }
  
  .hero-image {
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
  }
  
  .info-block {
    padding: 0.9375rem;
    border-radius: 0.5rem;
  }

  .partnership-section {
    margin-bottom: 20px;
  }
  
  .info-block h2 {
    font-size: 1.125rem;
  }
  
  .info-block h2.no-margin {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
  
  .info-block p {
    font-size: 0.875rem;
    margin-top: 0px;
    margin-bottom: 0.3125rem;
    line-height: 1.5;
  }
  
  .info-block.active {
    border-left: 0.25rem solid #47975a;
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  }
  .info-block {
    margin-bottom: 10px;
  }
  
  .partnership-card {
    padding: 10px;
    padding-bottom: 56px;
  }
  
  .contact-img {
    width: 12%;
    margin-bottom: 10px;
  }
  
  .partnership-card h3 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  
  .partnership-card p {
    font-size: 14px;
  }
}

.info-block.active {
  border-left: 4px solid #47975a;
  padding-left: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}
.status-boxes {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}
.status-box {
  background-color: #e9ecef;
  color: #555;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}
</style>